import API from "../api";
import {API_INSPECTION_ITEM, API_GET_OR_UPDATE_INSPECTION_ITEM, API_INSPECTION_METHOD} from "../constants/api";

async function getInspectionItems(template_id) {
  try {
    const response = await API.get(
      API_GET_OR_UPDATE_INSPECTION_ITEM(template_id)
    );
    const responseData = response.data;
    if (responseData.success === true) {
      return responseData.data;
    }
    return Promise.reject("Can not get templates");
  } catch (e) {
    throw e.response;
  }
}

const createInspections = async (formData) => {
  try {
    const headers = {
      'Content-Type': 'multipart/form-data; charset=utf-8'
    }
    const response = await API.post(API_INSPECTION_ITEM, formData, {headers});
    return response.data;
  } catch (e) {
    throw e;
  }
};

const updateInspections = async (formData, id) => {
  try {
    const headers = {
      'Content-Type': 'multipart/form-data; charset=utf-8'
    }
    const response = await API.put(
      API_INSPECTION_ITEM + "/" + id,
      formData,
      {
        headers: headers,
      }
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};

const updateTemplateInspections = async (updateData, template_id) => {
  try {
    const headers = {
      'Content-Type': 'application/json; charset=utf-8'
    }
    const payload = {
      template: updateData['template'],
      inspection_items: updateData['inspection_items']
    }
    const response = await API.post(
      API_GET_OR_UPDATE_INSPECTION_ITEM(template_id),
      JSON.stringify(payload), {headers}
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};

const deleteInspections = async (id) => {
  try {
    const headers = {
      'Content-Type': 'application/json; charset=utf-8'
    }
    const response = await API.delete(
      API_INSPECTION_ITEM + "/" + id,
      {
        headers: headers,
      }
    );
    return response.data;
  } catch (e) {
    throw e;
  }
};

/**
 * @param formData
 * @returns {Promise<any>}
 */
const createOrUpdateInspectionMethod = async (formData) => {
  try {
    const headers = {
      'Content-Type': 'multipart/form-data; charset=utf-8'
    }
    const payload = {
      ...formData,
      inspection_items: JSON.stringify(formData['inspection_items'])
    }
    const response = await API.post(API_INSPECTION_METHOD, payload, {headers: headers});
    return response.data;
  } catch (e) {
    throw e;
  }
};

export {
  getInspectionItems,
  createInspections,
  updateInspections,
  updateTemplateInspections,
  deleteInspections,
  createOrUpdateInspectionMethod,
}